import React, { Component, Fragment } from "react";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { withStyles } from "@material-ui/styles";
import { Toolbar } from "@material-ui/core";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import FormBuilderService from "../services/form-builder.service";
import { Box, Grid } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import { FormStore, formState, siteArrayState } from "../services/form.store";
import Alert from "@material-ui/lab/Alert";
import CloseIcon from "@material-ui/icons/Close";
import {
  Collapse,
  IconButton,
  Typography,
  Card,
  Button,
  Chip,
  TextField,
} from "@material-ui/core";
import { toast } from "react-toastify";
import DialogFooter from "./form-element/DialogFooter";
import { Autocomplete } from "@material-ui/lab";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { fetchRegions, fetchSites } from "../services/api-service";
import { CONDITIONAL_FORM } from "../utility/Constant";

const styles = (theme) => ({
  flexGrow: {
    flexGrow: 1,
  },
  ptag: {
    padding: "0px 12px",
  },
  formControl: {
    margin: "4px",
    borderRadius: 4,
    border: "1px solid grey",
    padding: "10px",
  },
  formLabel: {
    padding: "0px 5px",
    color: "#747a84",
  },
  appBar: {
    top: "auto",
    bottom: 0,
  },
  toolBar: {
    backgroundColor: "#242D3E",
    bottom: 0,
    top: "auto",
    position: "relative",
    width: "100%",
  },
  resetButton: {
    border: "1px solid white",
    color: "white",
  },
  underline: {
    "&&&:before": {
      borderBottom: "none",
    },
    "&&:after": {
      borderBottom: "none",
    },
  },
});

const MAX_REGIONS = 5;
const NO_REGIONS = 0;

class SiteandRegion extends Component {
  constructor(props) {
    super();
    let formType = "updateForm";
    this.state = {
      tagged: "Untagged",
      regions: [],
      sites: [],
      formRegion: [],
      formSiteRegion: [],
      valid: false,
      showAlert: false,
      checkedAllRegions: false,
      checkedAllSites: false,
      formType: formType,
      sitesTags: [],
      sitesError: false,
      sitesErrorMessage: "",
    };
    this.formBuilderService = new FormBuilderService();
  }

  handleSiteSorting = (item) => {
    return item.sort((a, b) =>
      a.properties.name.localeCompare(b.properties.name)
    );
  };

  componentDidMount() {
    fetchRegions().then((response) => {
      this.setState({
        regions: response.sort((a, b) =>
          a.siteGroupName.localeCompare(b.siteGroupName)
        ),
      });
      FormStore.sharedInstance().getAllSitesByRegionIds(response);
    });
    if (this.props.updateForm || this.props.copyForm) {
      this.formSubscription = formState.subscribe((response) => {
        if (response.formRegion && response.formRegion.length) {
          if (response.formRegion.length === MAX_REGIONS)
            this.setState({ checkedAllRegions: true });
          this.setState({
            formRegion: response.formRegion,
            tagged: "Site Tagging",
          });
          let sites = [];
          response.formRegion.forEach((formRegion, index) => {
            fetchSites(formRegion).then((response1) => {
              sites = sites.concat(response1);
              if (index === response.formRegion.length - 1) {
                this.setState({
                  formSiteRegion: response.formSiteRegion,
                });
                this.setState({ sites: this.handleSiteSorting(sites) });
              }
              this.setState({
                sitesTags: sites.filter((site) =>
                  response.formSiteRegion?.includes(site?.siteId)
                ),
              });
            });
          });
        }
      });
    } else {
      FormStore.sharedInstance().resetFormDetails();
    }
  }

  positionClick = (e, tagged) => {
    tagged && this.setState({ tagged: tagged });
    if (tagged === "Untagged") {
      this.setState({
        formRegion: [],
      });
      this.setState({
        formSiteRegion: [],
        sitesTags: [],
      });
      FormStore.sharedInstance().updateFormDetails("formSiteRegion", []);
      FormStore.sharedInstance().updateFormDetails("formRegion", []);
    }
  };

  regionChange = (event) => {
    if (
      event.target.value.includes("all") ||
      event.target.value?.length === NO_REGIONS ||
      event.target.value?.length === MAX_REGIONS
    ) {
      if (
        this.state.checkedAllRegions ||
        event.target.value?.length === NO_REGIONS
      ) {
        this.setState({
          checkedAllRegions: false,
          formRegion: [],
          formSiteRegion: [],
          sites: [],
          sitesTags: [],
          sitesError: false,
          sitesErrorMessage: "",
        });
        FormStore.sharedInstance().getFormDetails("formRegion", []);
        FormStore.sharedInstance().getFormDetails("formSiteRegion", []);
        if (this.props.updateForm || this.props.copyForm) {
          FormStore.sharedInstance().updateFormDetails("formRegion", []);
          FormStore.sharedInstance().updateFormDetails("formSiteRegion", []);
        }
      } else {
        const formRegionData = this.state.regions.map(
          (region) => region.siteGroupId
        );
        this.setState({ checkedAllRegions: true, formRegion: formRegionData });
        FormStore.sharedInstance().getFormDetails("formRegion", formRegionData);
        if (this.props.updateForm || this.props.copyForm) {
          FormStore.sharedInstance().updateFormDetails(
            "formRegion",
            formRegionData
          );
        }
        this.siteArraySubscription = siteArrayState.subscribe((sites) => {
          let siteDropdown = [];
          sites.forEach((site) => {
            siteDropdown.push(...site.siteArray);
            this.setState({ sites: this.handleSiteSorting(siteDropdown) });
          });
          this.setState({
            sitesTags: this.state.sitesTags?.filter((tag) =>
              siteDropdown?.some((site) => site?.siteId === tag?.siteId)
            ),
          });
          this.setState({
            formSiteRegion: this.state.formSiteRegion?.filter((siteId) =>
              siteDropdown?.some((site) => site?.siteId === siteId)
            ),
          });
        });
      }
    } else {
      const formRegionData = event.target.value;
      this.setState({ formRegion: formRegionData, checkedAllRegions: false });
      FormStore.sharedInstance().getFormDetails("formRegion", formRegionData);
      if (this.props.updateForm || this.props.copyForm) {
        FormStore.sharedInstance().updateFormDetails(
          "formRegion",
          formRegionData
        );
      }
      if (formRegionData.length) {
        this.siteArraySubscription = siteArrayState.subscribe((sites) => {
          let siteDropdown = [];
          sites.forEach((site) => {
            formRegionData.forEach((regionId) => {
              if (site.regionId === regionId) {
                siteDropdown.push(...site.siteArray);
                this.setState({ sites: this.handleSiteSorting(siteDropdown) });
              }
            });
          });
          const formSiteRegionData = this.state.formSiteRegion?.filter(
            (siteId) => siteDropdown?.some((site) => site?.siteId === siteId)
          );
          this.setState({
            sitesTags: this.state.sitesTags?.filter((tag) =>
              siteDropdown?.some((site) => site?.siteId === tag?.siteId)
            ),
          });
          this.setState({ formSiteRegion: formSiteRegionData });
          FormStore.sharedInstance().getFormDetails(
            "formSiteRegion",
            formSiteRegionData
          );
          if (this.props.updateForm || this.props.copyForm) {
            FormStore.sharedInstance().updateFormDetails(
              "formSiteRegion",
              formSiteRegionData
            );
          }
        });
      } else {
        this.setState({ sites: [], formSiteRegion: [], sitesTags: [] });
      }
    }
    if (
      !event.target.value.length ||
      event.target.value?.length === NO_REGIONS
    ) {
      this.setState({ sitesError: false, sitesErrorMessage: "" });
    }
  };

  alertClose = () => {
    this.setState({
      showAlert: false,
    });
  };

  siteChange = (event, value) => {
    if (value.length) {
      this.setState({
        formSiteRegion: value.map((site) => site.siteId),
        sitesTags: value.map((site) => site),
        sitesError: false,
        sitesErrorMessage: "",
      });
      FormStore.sharedInstance().getFormDetails(
        "formSiteRegion",
        value.map((site) => site.siteId)
      );
      if (this.props.updateForm || this.props.copyForm) {
        FormStore.sharedInstance().updateFormDetails(
          "formSiteRegion",
          value.map((site) => site.siteId)
        );
      }
    } else {
      const shouldShowError = this.state.formRegion.length > 0;
      this.setState({
        sitesTags: [],
        formSiteRegion: [],
        sitesError: shouldShowError,
        sitesErrorMessage: "",
      });
      FormStore.sharedInstance().getFormDetails("formSiteRegion", []);
      if (this.props.updateForm || this.props.copyForm) {
        FormStore.sharedInstance().updateFormDetails("formSiteRegion", []);
      }
    }
  };

  validateSitesSelection = () => {
    if (this.state.tagged !== "Site Tagging") {
      this.setState({
        sitesError: false,
        sitesErrorMessage: "",
      });
      return true;
    }

    if (
      this.state.formRegion.length > 0 &&
      (!this.state.formSiteRegion || this.state.formSiteRegion.length === 0)
    ) {
      this.setState({
        sitesError: true,
        sitesErrorMessage: "Please select sites when regions are selected",
      });
      return false;
    }
    this.setState({
      sitesError: false,
      sitesErrorMessage: "",
    });
    return true;
  };

  selectedRegionValues = (value) => {
    let newArr = this.state.regions
      .filter((region) => value.includes(region.siteGroupId))
      .map((region) => region.siteGroupName);
    return newArr.join(", ");
  };

  formResetHandler = () => {
    this.setState({
      formRegion: [],
      formSiteRegion: [],
      showAlert: false,
      checkedAllRegions: false,
      checkedAllSites: false,
      sites: [],
      sitesTags: [],
      sitesError: false,
      sitesErrorMessage: "",
    });
  };

  formSubmitHandler = () => {
    let isValid = this.props.validate.validateForm();
    const isSitesValid = this.validateSitesSelection();
    const finalValid = isValid && isSitesValid;
    this.setState({
      valid: finalValid,
      showAlert: !isValid,
    });
    if (!finalValid) return;
    FormStore.sharedInstance().checkFormValid(finalValid);
    if (finalValid === true) {
      FormStore.sharedInstance().getFormDetails(
        "formSiteRegion",
        this.state.formSiteRegion
      );
      const formValues = FormStore.sharedInstance().sendFormDetails();
      if (this.props.isConditionalForm) {
        formValues.isConditionalForm = this.props.isConditionalForm;
        formValues.universalHierarchy = this.props.universalHierarchyData;
      }
      this.formBuilderService.createForm(formValues).then((res) => {
        if (res.data) {
          const formId = res.data;
          this.props.history.push("/editForm/" + formId);
          toast.success("Form created successfully!");
        } else {
          toast.error("Form could not be created due to errors!");
        }
      });
    }
  };

  closeDialog = () => {
    FormStore.sharedInstance().loadInitialFormState();
    FormStore.sharedInstance().showDialog(false);
  };

  formChangeHandler = () => {
    let isValid = this.props.validate.validateForm();
    const isSitesValid = this.validateSitesSelection();
    const finalValid = isValid && isSitesValid;
    this.setState({
      valid: finalValid,
      showAlert: !isValid,
    });
    if (!finalValid) return;
    FormStore.sharedInstance().checkFormValid(finalValid);
    if (finalValid) {
      if (this.props.updateForm) {
        FormStore.sharedInstance().updateFormMetaData(this.state.formType);
        return;
      } else if (this.props.copyForm) {
        this.setState(
          {
            formType: "copyForm",
          },
          () => {
            FormStore.sharedInstance().updateFormMetaData(this.state.formType);
          }
        );
      } else {
        return;
      }
    }
  };

  siteFilterOptions = (options, state) => {
    const { inputValue } = state;
    return options?.filter((option) =>
      option.properties.name.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  render() {
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    const { classes } = this.props;
    return (
      <div>
        <Fragment>
          <Card
            square
            variant="outlined"
            style={{ width: "96%", margin: "2%" }}
          >
            <Toolbar>
              <Typography variant="h6">
                Site &amp; Region Restriction
              </Typography>
              <div className={classes.flexGrow} />
              <ToggleButtonGroup
                size="small"
                exclusive
                aria-label="text alignment"
                value={this.state.tagged}
                onChange={this.positionClick}
              >
                <ToggleButton value="Untagged" aria-label="Untagged">
                  Untagged
                </ToggleButton>
                <ToggleButton value="Site Tagging" aria-label="Site Tagging">
                  Site Tagging
                </ToggleButton>
              </ToggleButtonGroup>
            </Toolbar>
            <p className={classes.ptag}>
              If this form is to be tagged with specific site, please select
              Site Tagging.{" "}
            </p>
            {this.state.tagged === "Site Tagging" ? (
              <Box p={3}>
                <Grid container spacing={3}>
                  <Grid item md={5} xs={10}>
                    <Typography className={classes.formLabel}>
                      SELECT REGIONS
                    </Typography>
                    <FormControl
                      fullWidth
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <Select
                        className={classes.underline}
                        labelId="demo-mutiple-checkbox-label"
                        id="demo-mutiple-checkbox"
                        multiple
                        value={this.state.formRegion}
                        onChange={this.regionChange}
                        input={<Input />}
                        renderValue={(selected) =>
                          this.selectedRegionValues(selected)
                        }
                        MenuProps={{
                          variant: "menu",
                          PaperProps: { style: { marginTop: 60 } },
                        }}
                      >
                        {this.state.regions.length > 0 ? (
                          <MenuItem key="all" value="all">
                            <Checkbox checked={this.state.checkedAllRegions} />
                            <ListItemText primary="Select All" />
                          </MenuItem>
                        ) : null}
                        {this.state.regions.map((region) => (
                          <MenuItem
                            key={region.siteGroupName}
                            value={region.siteGroupId}
                          >
                            <Checkbox
                              checked={
                                this.state.formRegion.indexOf(
                                  region.siteGroupId
                                ) > -1
                              }
                            />
                            <ListItemText primary={region.siteGroupName} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={1} xs={2}></Grid>
                  <Grid item md={5} xs={10}>
                    <Typography className={classes.formLabel}>
                      SELECT SITES{" "}
                      {this.state.formRegion.length > 0 && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                    </Typography>
                    <Autocomplete
                      multiple
                      id="checkboxes-tags-demo"
                      options={this.state.sites}
                      onChange={this.siteChange}
                      disableCloseOnSelect
                      value={this.state.sitesTags}
                      filterOptions={this.siteFilterOptions}
                      getOptionLabel={(option) =>
                        option
                          ? option.properties
                            ? option.properties.name
                            : ""
                          : ""
                      }
                      getOptionSelected={(option, value) =>
                        option.properties.name === value.properties.name
                      }
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                          <Chip
                            id="chip"
                            size="small"
                            label={
                              option
                                ? option.properties
                                  ? option.properties.name
                                  : ""
                                : ""
                            }
                            {...getTagProps({ index })}
                          />
                        ))
                      }
                      renderOption={(option, { selected }) => (
                        <React.Fragment>
                          <Checkbox
                            id="checkboxIcon"
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option
                            ? option.properties
                              ? option.properties.name
                              : ""
                            : ""}
                        </React.Fragment>
                      )}
                      style={{ width: "100%" }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          id="siteTextField"
                          variant="outlined"
                          required={this.state.formRegion.length > 0}
                          error={this.state.sitesError}
                          helperText={
                            this.state.sitesError
                              ? this.state.sitesErrorMessage
                              : ""
                          }
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Box>
            ) : null}
            <br></br>
            <Collapse in={this.state.showAlert && !this.state.sitesError}>
              <Alert
                variant="filled"
                severity="error"
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={this.alertClose}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
              >
                You have missed out few validations! Please check the Form
                Details page and fill the fields with proper values!
              </Alert>
            </Collapse>
            {this.props.updateForm || this.props.copyForm ? (
              <DialogFooter
                cancel={this.closeDialog}
                disabled={this.isEnabled}
                save={this.formChangeHandler}
                copyForm={this.props.copyForm}
                isButtonDisabled={this.props.isConditionalLoading}
              />
            ) : (
              <AppBar className={classes.appBar}>
                <Toolbar className={classes.toolBar}>
                  <span className={classes.flexGrow} />
                  <Button
                    id="reset"
                    className={classes.resetButton}
                    variant="outlined"
                    color="inherit"
                    disableElevation
                    onClick={this.formResetHandler}
                  >
                    Reset
                  </Button>
                  <Button
                    variant="contained"
                    disableElevation
                    onClick={this.formSubmitHandler}
                  >
                    Create Form
                  </Button>
                </Toolbar>
              </AppBar>
            )}
          </Card>
        </Fragment>
      </div>
    );
  }
}

export default withStyles(styles)(SiteandRegion);
